<template>
<div>
  <div class="table-wrap">
    <el-table :data="pageData.list" style="width: 100%">

      <el-table-column prop="process_name" label="流程名称" width="250"></el-table-column>
      <el-table-column prop="serial_number" label="流水号" width="250"></el-table-column>
      <el-table-column prop="node_name" label="节点名称" width="180"></el-table-column>
      <el-table-column prop="name" label="节点审批人" width="100"></el-table-column>
      <el-table-column prop="ancestor_name" label="部门" width="180"></el-table-column>
      <el-table-column prop="status" label="流程状态" width="100">
        <template slot-scope="scope">
          <template v-if="scope.row.is_finish">
            <el-tag type="success">已结束</el-tag>
          </template>
          <template v-else>
            <el-tag v-if="scope.row.status != 9 && scope.row.status != 10 && scope.row.status != 11" >执行中</el-tag>
            <el-tag v-if="scope.row.status == 9" type="danger">拒绝</el-tag>
            <el-tag v-if="scope.row.status == 10" type="danger">撤回</el-tag>
            <el-tag v-if="scope.row.status == 11" type="danger">退回重填</el-tag>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="receive_time_text" label="节点接收时间"></el-table-column>
      <el-table-column prop="finish_time_text" label="处理时间" width="180"></el-table-column>
      <el-table-column prop="timeout" label="审批时长(单位:小时)"></el-table-column>
      <template>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="detailFlowNode(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </div>

  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
  </div>


  <el-dialog title="查看" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px">

    <el-row>
      <el-col :span="24">
        <div>
          <v-form-render v-if="form_status" :form-json="formJson" :form-data="formData" :option-data="optionData"  ref="vFormRef">
          </v-form-render>
        </div>
      </el-col>
    </el-row>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
    </div>
  </el-dialog>

</div>
</template>

<script>
import Http from "../common/Http";
import FlowHandle from "./FlowHandle";

export default {
  name: "FlowTimeoutLog",
  components: {FlowHandle},
  props:{
    where:{
      type:Object,
      default(){
        return {};
      }
    },
  },
  data(){
    return{
      $_where:{},
      loading:false,
      dialogVisible:false,
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      optionData: {},
      formJson: {},
      formData: {},
      form_status: false,
    }
  },
  provide() {
    return {
      __FLOW_PAGE__:this
    }
  },
  activated() {
    this.getList()
  },
  watch:{
    where:{
      deep:true,
      immediate:true,
      handler(n){
        n&&this.searchList();
      }
    }
  },
  methods:{
    searchList () {
      this.pageData.page = 1
      this.pageData.pageSize = 20
      this.getList()
    },
    getList() {
      const that = this;
      that.loading=true;
      let where=JSON.parse(JSON.stringify(that.where));
      Http.get("flow/FlowTimeoutLog/logList",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    detailFlowNode(row){
      let that = this
      this.dialogVisible = true
      this.loading = true
      let task_id = row.task_id;
      // 获取FormData
      Http.get("flow/FlowForm/getFormData",{
        task_id: task_id,
      },res=>{
        if(res.code) {
          console.info(res.data)
          that.form_status=false;
          that.$nextTick(function () {
            that.formData = res.data
            that.form_status=true;
            that.$nextTick(function () {
              that.$refs.vFormRef.setGraphData(that.graph_data);
              that.$refs.vFormRef.setFormJson(res.data.form_json);
              that.$nextTick(function () {
                that.$refs.vFormRef.disableForm()
              })
            })
          })
        }
      })
    },
    getDateTime() {},
    getUserInfo() {},
  },
}
</script>

<style lang="scss" scoped>
@import "../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/FlowTimeoutLog.vue